'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
exports['default'] = {
  INIT: 'redux-localstorage/INIT'
};
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/redux-localstorage/lib/actionTypes.js
// module id = ./node_modules/redux-localstorage/lib/actionTypes.js
// module chunks = 154